import { render, staticRenderFns } from "./ColorList.vue?vue&type=template&id=73d2b980&scoped=true"
import script from "./ColorList.vue?vue&type=script&lang=js"
export * from "./ColorList.vue?vue&type=script&lang=js"
import style0 from "./ColorList.vue?vue&type=style&index=0&id=73d2b980&prod&lang=scss"
import style1 from "./ColorList.vue?vue&type=style&index=1&id=73d2b980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d2b980",
  null
  
)

export default component.exports